import {config} from "@mobiusjs/site-client";

config.options = require('./config.options').default

let prodConfig = {}
try {
    prodConfig = require('./config.prod').default
} catch (e) {
    console.log('No production config defined')
}

export default {
    ...config,
    version: '1.6.11',
    debug: true,
    soon: false,
    prefix: 'egift_',
    name: 'egift_site',
    title: 'eGiftCards',
    description: "",
    robots: "noindex, nofollow",
    directives: {
        connectSrc: [],
        imgSrc: [],
        fontSrc: []
    },
    modules: {
        library: {...config.modules.library},
        custom: {}
    },
    projects: {
        single: true,
        default: 'giftcard',
        projects: ['giftcard']
    },
    lang: {
        multiLang: true,
        default: 'az',
        languages: ['az', 'en', 'ru']
    },
    curr: {
        multiCurr: true,
        default: 'azn',
        currencies: ['usd', 'eur', 'azn']
    },
    company: {
        established: 2012,
        title: 'Sinteks'
    },
    ssl: true,
    urls: {
        api: '',
        cdn: '',
        site: ''
    },
    routes: {
        hasStatic: true
    },
    giftCard: {
        url: 'http://213.172.90.237:82/sinteks_retail/hs/GetCertCode/GetInfoOfCertCode?NumberOfSeries=',
        prodUrl: 'http://213.172.90.237:82/sinteks_retail/hs/GetCertCode/GetInfoOfCertCode?NumberOfSeries=',
        testUrl: 'http://213.172.90.237:82/Sinteks-Retail_Outsource-1/hs/GetCertCode/GetInfoOfCertCode?NumberOfSeries=',
        user: 'webex',
        pass: 'webex@123',
        stores: {
            'Albatros 1': {
                logo: 'Albatros',
                title: 'Albatros',
                address: '128,Ataturk av.',
                mobile: '+994 50 520-80-47'
            },
            'Albatros 3': {
                logo: 'Albatros',
                title: 'Albatros',
                address: '26, Bakikhanov str.',
                mobile: '+994 50 277-80-81'
            },
            'Albatros 4': {
                logo: 'Albatros',
                title: 'Albatros',
                address: 'R.Behbudov,50',
                mobile: '+994 50 255-44-64'
            },
            'Albatros 5': {
                logo: 'Albatros',
                title: 'Albatros',
                address: '3, R.Rza str.',
                mobile: '+994 50 229-60-20'
            },
            'Alexander McQueen': {
                logo: 'AlexanderMcQueen',
                title: 'Alexander McQueen',
                address: 'Port Baku Mall',
                mobile: '+994 50 262-90-60',
                class: 'alexander'
            },
            'Armani Exchange': {
                logo: 'ArmaniExchange',
                title: 'Armani Exchange',
                address: '27, Zarifa Aliyeva av.',
                mobile: '+994 51 229-42-29',
                class: 'armani'
            },
            'Bottega Veneta': {
                logo: 'BottegaVeneta',
                title: 'Bottega Veneta',
                address: '2, Z.Tagiyev str.',
                mobile: '+994 50 278-60-61',
                class: 'bottega'
            },
            'Balenciaga': {
                logo: 'Balenciaga',
                title: 'Balenciaga',
                address: 'Port Baku Mall',
                mobile: '+994 50 262-30-20',
                class: 'balenciaga'
            },
            'Bally': {
                logo: 'Bally',
                title: 'Bally',
                address: 'Port Baku Mall',
                mobile: '+994 50 259-10-60',
                class: 'bally'
            },
            'Bisque': {
                logo: 'Bisque',
                title: 'Bisque',
                address: '127, Neftchilar av.',
                mobile: ['+994 50 259-10-60', '+994 50 281-88-84'],
                class: 'bisque'
            },
            'Burberry Kids': {
                logo: 'BurberryKids',
                title: 'Burberry Kids',
                address: '121, Neftchilar av.',
                mobile: ['+994 50 291-96-92', '+994 50 218-65-98']
            },
            'Burberry PBR': {
                logo: 'Burberry',
                title: 'Burberry PBR',
                address: 'Port Baku Mall',
                mobile: ['+994 50 228-54-80', '+994 50 262-80-30'],
                class: 'burberry'
            },
            'Corneliani': {
                logo: 'Corneliani',
                title: 'Corneliani',
                address: '89 , Neftchilar av.',
                mobile: '+994 50 503-50-90',
                class: 'corneliani'
            },
            'Chloe': {
                logo: 'Chloe',
                title: 'Chloe',
                address: 'Port Baku Mall',
                mobile: '+994 50 262-10-90',
                class: 'chloe'
            },
            'Diane Von Furstenberg': {
                logo: 'DianeVonFurstenberg',
                title: 'Diane Von Furstenberg',
                address: 'Port Baku Mall',
                mobile: '+994 50 262-40-10',
                class: 'diane'
            },
            'Diesel': {
                logo: 'Diesel',
                title: 'Diesel',
                address: 'Port Baku Mall',
                mobile: '+994 50 275-77-44',
                class: 'diesel'
            },
            'Dolce Gabbana Kids': {
                logo: 'DolceGabbanaKids',
                title: 'Dolce Gabbana Kids',
                address: '13B,Neftchilar av.',
                mobile: ['+994 50 245-77-76', '+994 50 289-16-88'],
                class: 'dolce'
            },
            'Emporio Armani PBR': {
                logo: 'EmporioArmani',
                title: 'Emporio Armani',
                address: '13B,Neftchilar av.',
                mobile: ['+994 50 277-80-87', '+994 50 255-81-87']
            },
            'Emporio Armani': {
                logo: 'EmporioArmani',
                title: 'Emporio Armani',
                address: '13B,Neftchilar av.',
                mobile: ['+994 50 250-37-97', '+994 50 250-76-74'],
                class: 'emporio'
            },
            'Zegna': {
                logo: 'Zegna',
                title: 'Zegna',
                address: '89, Neftchilar av.',
                mobile: '+994 50 520-80-46',
                class: 'zegna'
            },
            'Etro': {
                logo: 'Etro',
                title: 'Etro',
                address: 'Port Baku Mall',
                mobile: ['+994 50 295-89-39', '+994 50 235-91-91'],
                class: 'etro'
            },
            'Ermanno Scervino': {
                logo: 'ErmannoScervino',
                title: 'Ermanno Scervino',
                address: 'Port Baku Mall',
                mobile: '+994 50 493-33-96',
                class: 'ermanno'
            },
            'Givenchy': {
                logo: 'Givenchy',
                title: 'Givenchy',
                address: 'Port Baku Mall',
                mobile: '+994 50 259-10 -70',
                class: 'givenchy'
            },
            'Giorgio Armani': {
                logo: 'GiorgioArmani',
                title: 'Giorgio Armani',
                address: 'Port Baku Mall',
                mobile: ['+994 50 262-32-02', '+994 50 277-51-54'],
                class: 'giorgio'
            },
            'GUESS': {
                logo: 'Guess',
                title: 'GUESS',
                address: '4, Aziz Aliyeva str.',
                mobile: ['+994 50 255-29-25', '+994 50 255-87-80'],
                class: 'guess'
            },
            'GUESS by Marciano': {
                logo: 'GuessByMarciano',
                title: 'GUESS by Marciano',
                address: 'Port Baku Mall',
                mobile: '+994 50 287-66-55',
            },
            'GUCCI': {
                logo: 'Gucci',
                title: 'GUCCI',
                address: '2, Z.Tagiyev str.',
                mobile: ['+994 50 245-11-15', '+994 50 245-11-25'],
                class: 'gucci'
            },
            'Gucci Kids': {
                logo: 'GucciKids',
                title: 'Gucci Kids',
                address: '13 B, Neftchilar av.',
                mobile: ['+994 50 283-00-11', '+994 50 246-83-98'],
                class: 'gucci-kids'
            },
            'Hugo Boss': {
                logo: 'Boss',
                title: 'Hugo Boss',
                address: 'Port Baku Mall',
                mobile: '+994 50 277-80-85',
                class: 'boss'
            },
            'Hugo Boss 2': {
                logo: 'Boss',
                title: 'Hugo Boss',
                address: '3,R.Rza str.',
                mobile: '+994 50 278-60-60',
                class: 'boss'
            },
            'Isaia': {
                logo: 'Isaia',
                title: 'Isaia',
                address: '7 B, Neftchilar av.',
                mobile: '+994 50 263-44-88'
            },
            'Jimmy Choo': {
                logo: 'JimmyChoo',
                title: 'Jimmy Choo',
                address: 'Port Baku Mall',
                mobile: '+994 50 265-60-20',
                class: 'jimmy'
            },
            'Karl LagerFeld': {
                logo: 'KarlLagerFeld',
                title: 'Karl Lagerfeld',
                address: 'Port Baku Mall',
                mobile: '+994 50 255-87-88',
                class: 'karl'
            },
            'Kiton': {
                logo: 'Kiton',
                title: 'Kiton',
                address: '5, R.Behbudov str.',
                mobile: '+994 50 240-02-40'
            },
            'Lloyd': {
                logo: 'Lloyd',
                title: 'Lloyd',
                address: 'Port Baku Mall',
                mobile: '+994 50 245-15-11',
                class: 'lloyd'
            },
            'Michael Kors': {
                logo: 'MichaelKors',
                title: 'Michael Kors',
                address: 'Port Baku Mall',
                mobile: ['+994 50 262-26-20', '+994 50 283-71-70'],
                class: 'michael'
            },
            'Marc Jacobs': {
                logo: 'MarcJacobs',
                title: 'Marc Jacobs',
                address: 'Port Baku Mall',
                mobile: '+994 50 262-90-10',
                class: 'marc'
            },
            'Maje': {
                logo: 'Maje',
                title: 'Maje',
                address: 'Port Baku Mall',
                mobile: '+994 50 255-83-83',
                class: 'maje'
            },
            'Marina Rinaldi 1': {
                logo: 'MarinaRinaldi',
                title: 'Marina Rinaldi',
                address: '83, Neftchilar av.',
                mobile: ['+994 50 445-80-50', '+994 50 278-33-43'],
                class: 'marina'
            },
            'Marina Rinaldi 2': {
                logo: 'MarinaRinaldi',
                title: 'Marina Rinaldi',
                address: 'R.Behbudov,50',
                mobile: ['+994 50 291-96-90', '+994 50 278-33-44'],
                class: 'marina'
            },
            'Max Mara': {
                logo: 'MaxMara',
                title: 'Max Mara',
                address: 'Port Baku Mall',
                mobile: '+994 50 277-80-83',
                class: 'max-mara'
            },
            'Weekend Max Mara': {
                logo: 'WeekendMaxMara',
                title: 'Weekend Max Mara',
                address: 'Port Baku Mall',
                mobile: '+994 50 277-80-84',
                class: 'weekend'
            },
            'Max Co PBR': {
                logo: 'MaxAndCo',
                title: 'Max&Co',
                address: 'Port Baku Mall',
                mobile: ['+994 50 277-80-86', '+994 50 240-34-45'],
                class: 'max-and-co'
            },
            'Patrizia Pepe': {
                logo: 'PatriziaPepe',
                title: 'Patrizia Pepe',
                address: 'Port Baku Mall',
                mobile: '+994 51 229-06-79',
                class: 'patrizia'
            },
            'Paul and Shark': {
                logo: 'PaulAndShark',
                title: 'Paul & Shark',
                address: 'Port Baku Mall',
                mobile: '+994 51 225-80-72',
                class: 'paul'
            },
            'Persona by Marina Rinaldi': {
                logo: 'PersonaByMarinaRinaldi',
                title: 'Persona by Marina Rinaldi',
                address: 'Port Baku Mall',
                mobile: '+994 51 229-06-76',
                class: 'persona'
            },
            'Ralph Lauren': {
                logo: 'RalphLauren',
                title: 'Ralph Lauren',
                address: 'Port Baku Mall',
                mobile: ['+994 50 262-32-00', '+994 50 277-51-61'],
                class: 'ralph'
            },
            'Sandro': {
                logo: 'Sandro',
                title: 'Sandro',
                address: 'Port Baku Mall',
                mobile: '+994 50 262-30-60',
                class: 'sandro'
            },
            'Ferragamo': {
                logo: 'Ferragamo',
                title: 'Ferragamo',
                address: '97, Neftchiler av.',
                mobile: ['+994 50 255-82-22', '+994 50 255-82-28'],
                class: 'ferragamo'
            },
            'Scoop': {
                logo: 'Scoop',
                title: 'Scoop',
                address: '2, Z.Tagiyev str.',
                mobile: ['+994 50 503-50-10', '+994 50 790-26-26', '+994 50 316-26-26'],
                class: 'scoop'
            },
            'Stella McCartney': {
                logo: 'StellaMcCartney',
                title: 'Stella McCartney',
                address: 'Port Baku Mall',
                mobile: '+994 50 259-10-90',
                class: 'stella'
            },
            'Tods': {
                logo: 'Tods',
                title: 'Tods',
                address: 'Port Baku Mall',
                mobile: '+994 50 291-99-65',
                class: 'tods'
            },
            'Tory Burch': {
                logo: 'ToryBurch',
                title: 'Tory Burch',
                address: 'Port Baku Mall',
                mobile: ['+994 50 262-90-70', '+994 50 289-16-41'],
                class: 'tory'
            },

            'Emporium Beauty': {
                logo: 'Emporium',
                title: 'Emporium Beauty',
                address: 'Port Baku Mall',
                mobile: '+994 50 254-07-96'
            },
            'Emporium Home': {
                logo: 'Emporium',
                title: 'Emporium Home',
                address: 'Port Baku Mall',
                mobile: ['+994 50 283-50-05', '+994 50 250-57-24'],
            },
            'Emporium Jewellery':  {
                logo: 'Emporium',
                title: 'Emporium Jewellery',
                address: 'Port Baku Mall',
                mobile: '+994 50 294-99-00',
            },
            'Emporium Kids': {},
            'Emporium Man': {
                logo: 'Emporium',
                title: 'Emporium Man',
                address: 'Port Baku Mall',
                mobile: ['+994 50 277-51-55', '+994 50 277-51-56'],
            },
            'Emporium Woman': {
                logo: 'Emporium',
                title: 'Emporium Woman',
                address: 'Port Baku Mall',
                mobile: ['+994 50 283-50-00', '+994 50 218-28-34'],
            },
            'Emporium SA': {},
            'Emporium Young': {
                logo: 'Emporium',
                title: 'Emporium Kids',
                address: 'Port Baku Mall',
                mobile: ['+994 50 254-54-27', '+994 51 206-47-49'],
            },
            'Emporium Junior': {
                logo: 'Emporium',
                title: 'Emporium Junior',
                address: 'Port Baku Mall',
                mobile: '+994 50  218-46-69',
            },

            // 'Cavalli': {title: 'Cavalli'},
            // 'Celio': {title: 'Celio'},
            // 'DSquared': {title: 'DSquared'},
            // 'Emilio Pucci': {title: 'Emilio Pucci'},
            // 'Escada': {title: 'Escada'},
            // 'Etro-PBR': {title: 'Etro-PBR'},
            // 'Marni': {title: 'Marni'},
            // 'Pal Zileri': {
            //     logo: 'PalZileri',
            //     title: 'Pal Zileri',
            //     address: '83, Neftchilar av.',
            //     mobile: '+994 50 385-50-73',
            //     class: 'pal'
            // },
            // 'StJohn': {
            //     logo: 'StJohn',
            //     title: 'StJohn'
            // },
            // 'Valentino Red': {title: 'Valentino Red'},
        }
    },
    ...prodConfig
}
